/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type RecipeDetails_recipe$ref = any;
type RecipeInfo_recipe$ref = any;
type SectionsList_recipe$ref = any;
type StepsList_recipe$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type Recipe_recipe$ref: FragmentReference;
declare export opaque type Recipe_recipe$fragmentType: Recipe_recipe$ref;
export type Recipe_recipe = {|
  +id: string,
  +name: string,
  +published: boolean,
  +favoritedBy: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +username: string
      |}
    |}>
  |},
  +labels: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: string,
      |}
    |}>
  |},
  +recipeingredientSet: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +comments: ?string,
        +ingredient: {|
          +id: string,
          +name: string,
        |},
        +unityF: ?{|
          +id: string
        |},
        +qty: ?string,
        +section: ?{|
          +id: string,
          +name: ?string,
        |},
        +fraction: ?string,
      |}
    |}>
  |},
  +recipeallergen: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +allergen: {|
          +id: string,
          +name: string,
          +icon: ?string,
        |},
      |}
    |}>
  |},
  +mediaFiles: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +mediaUrl: ?string,
      |}
    |}>
  |},
  +$fragmentRefs: RecipeInfo_recipe$ref & RecipeDetails_recipe$ref & StepsList_recipe$ref & SectionsList_recipe$ref,
  +$refType: Recipe_recipe$ref,
|};
export type Recipe_recipe$data = Recipe_recipe;
export type Recipe_recipe$key = {
  +$data?: Recipe_recipe$data,
  +$fragmentRefs: Recipe_recipe$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "recipeallergen"
        ]
      }
    ]
  },
  "name": "Recipe_recipe",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "published",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserNodeConnection",
      "kind": "LinkedField",
      "name": "favoritedBy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "username",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LabelNodeConnection",
      "kind": "LinkedField",
      "name": "labels",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LabelNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LabelNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecipeIngredientNodeConnection",
      "kind": "LinkedField",
      "name": "recipeingredientSet",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RecipeIngredientNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecipeIngredientNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "comments",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IngredientNode",
                  "kind": "LinkedField",
                  "name": "ingredient",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UnitMeasureNode",
                  "kind": "LinkedField",
                  "name": "unityF",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "qty",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "RecipeSectionNode",
                  "kind": "LinkedField",
                  "name": "section",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fraction",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "recipeallergen",
      "args": null,
      "concreteType": "RecipeAllergenNodeConnection",
      "kind": "LinkedField",
      "name": "__allergens_recipeallergen_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RecipeAllergenNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecipeAllergenNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AllergenNode",
                  "kind": "LinkedField",
                  "name": "allergen",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "icon",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RecipeMediaNodeConnection",
      "kind": "LinkedField",
      "name": "mediaFiles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RecipeMediaNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecipeMediaNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "mediaUrl",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecipeInfo_recipe"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecipeDetails_recipe"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StepsList_recipe"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SectionsList_recipe"
    }
  ],
  "type": "RecipeNode"
};
})();
// prettier-ignore
(node/*: any*/).hash = '7dd5b43d0b63970d0d2a4a2b2c6558f2';

module.exports = node;
